import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocalStorage } from "../../store/mahutiLocalStorage";
import { setCartDiscountRate, setCustomerDetails, setIsStepFourLoading, setOpportunity } from "../../store/MahutiReducer";
import { getAmount, patchOpportunitySF } from "../../utils/sfUtils";
import MahutiInputText from "../mahuti-input-text/MahutiInputText";
import { PAYMENT_IN_PROCESS, scrollToSection } from "../../utils/GlobalParams";
import './CustomerDetails.css'
import { Link } from "react-router-dom";
import { isMobile } from "react-device-detect";


function CustomerDetails(props) {
    const store = useSelector(store => store.reducer);
    const [getLocalStorage, setLocalStorage] = useLocalStorage();
    const dispatch = useDispatch();
    const [errors, setErrors] = useState({})
    const [fields, setFields] = useState({})
    const [couponLoader, setCouponLoader] = useState(false)
    const opportunityId = store.opportunity?.id;
    let customerDetailObj =  getLocalStorage('customerDetails') ? getLocalStorage('customerDetails') : {};
    const customerFormErrors = store.customerFormErrors


    useEffect(()=> {
        if(customerDetailObj) {
            dispatch(setCustomerDetails(customerDetailObj));
        }
    },[])

    const setCustomerState = (value, customerDetailKey) => {
        if(customerDetailKey === 'approvingCondition'){
            value = value.target.checked
        }
        if(customerDetailKey === 'email'){
            value = value.toLowerCase()
        }
        customerDetailObj = store.customerDetails
        customerDetailObj = {...customerDetailObj, [customerDetailKey]: value};
        setLocalStorage('customerDetails', customerDetailObj);
        dispatch(setCustomerDetails(customerDetailObj));
    }

    const setCoupon = (e) => {
        e.preventDefault();
        if(customerDetailObj.codeCoupon){
            setCouponLoader(true)
            dispatch(setIsStepFourLoading(true));
            patchOpportunitySF(customerDetailObj.codeCoupon, opportunityId,PAYMENT_IN_PROCESS, store.customerDetails, false).then(res => {
                let discountAmount = res.data.discount;
                dispatch(setOpportunity({ amount: res.data.amount, discount: discountAmount }));
                res.data.discountRate && res.data.discountRate > 0 && dispatch(setCartDiscountRate(res.data.discountRate))
                setErrors({...errors, coupon: undefined})
            })
            .catch(() => {
                setErrors({...errors, coupon: 'קופון לא חוקי'})
            })
            .finally(() => {
                dispatch(setIsStepFourLoading(false));
                setCouponLoader(false)
            })
        }
    }


    return  <div className="customerDetails mt-1">   
                <h4 className={`text-start customer_details_title my-lg-4 mb-3 mt-1 ${isMobile ? 'almoni_tzar_bold' : 'almoni_tzar_normal'}`}> פרטי המזמין:</h4>
                <div className="pb-4">
                    <div className="row gx-0 gx-lg-3">
                        <div className={`col-lg-6 col-12 relative ${isMobile && 'pb-4'}`}>
                            <div id="firstName_scroll" className="scroll_div"></div>
                            <MahutiInputText error={customerFormErrors.firstName ? 'error' : ''} defaultValue={customerDetailObj && customerDetailObj.firstName ? customerDetailObj.firstName : ''} onChange={setCustomerState} label='שם פרטי' id='firstName' required/>
                            {customerFormErrors.firstName && <div className="input_alert">{customerFormErrors.firstName}</div>}
                        </div>
                        <div className="col-lg-6 col-12 relative">
                            <div id="lastName_scroll" className="scroll_div"></div>
                            <MahutiInputText error={customerFormErrors.lastName ? 'error' : ''} defaultValue={customerDetailObj && customerDetailObj.lastName ? customerDetailObj.lastName : ''} onChange={setCustomerState} label='שם משפחה' id='lastName' required/>
                            {customerFormErrors.lastName && <div className="input_alert">{customerFormErrors.lastName}</div>}
                        </div>
                    </div>
                </div>
                <div className="">
                    <div className="">
                        <div className="pb-4 relative">
                            <div id="phoneNumber_scroll" className="scroll_div"></div>
                            <MahutiInputText error={customerFormErrors.phoneNumber ? 'error' : ''} defaultValue={customerDetailObj && customerDetailObj.phoneNumber ? customerDetailObj.phoneNumber : ''} onChange={setCustomerState} label='טלפון' id='phoneNumber' required/>
                            {customerFormErrors.phoneNumber && <div className="input_alert">{customerFormErrors.phoneNumber}</div>}
                        </div>
                        <div className="pb-4 relative">
                            <div id="email_scroll" className="scroll_div"></div>
                            <MahutiInputText error={customerFormErrors.email ? 'error' : ''} defaultValue={customerDetailObj && customerDetailObj.email ? customerDetailObj.email : ''} type='email' onChange={setCustomerState} label='אימייל' id='email' required/>
                            {customerFormErrors.email && <div className="input_alert">{customerFormErrors.email}</div>}
                        </div>

                        <div className="pb-4 relative">
                            <div id="companyName_scroll" className="scroll_div"></div>
                            <MahutiInputText defaultValue={customerDetailObj && customerDetailObj.companyName ? customerDetailObj.companyName : ''} onChange={setCustomerState} label='חברה' id='companyName' />
                        </div>
                        <div className="pb-4 relative">
                            <div id="city_scroll" className="scroll_div"></div>
                            <MahutiInputText error={customerFormErrors.city ? 'error' : ''} defaultValue={customerDetailObj && customerDetailObj.city ? customerDetailObj.city : ''} label='עיר' onChange={setCustomerState} id='city' required/>
                            {customerFormErrors.city && <div className="input_alert">{customerFormErrors.city}</div>}
                        </div>
                        <div className="pb-4">
                            <div className="row flex-grow-1">
                                <div className="col-8 d-flex flex-column">
                                    <MahutiInputText error={errors.coupon ? 'error' : ''} defaultValue={customerDetailObj && customerDetailObj.codeCoupon ? customerDetailObj.codeCoupon : ''} id='codeCoupon' label='הזן קוד קופון' onChange={setCustomerState} />
                                    {errors.coupon && <div className="input_alert">{errors.coupon}</div>}
                                    {store.cartDiscountAmount > 0 && <div className="tiny_msg">קופון אושר</div>}
                                </div>
                                <div className="col-4">
                                    <button className="form-control btn-mahuty-light text-mahuti rounded-0 d-flex justify-content-center align-items-center" type='submit' htmlFor='copon' onClick={(e) => setCoupon(e)} disabled={(store.isStepFourLoading || store.cartDiscountAmount > 0) && 'disabled'}>
                                        ממש קופון
                                        {couponLoader && <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>}
                                    </button>
                                </div>

                            </div>
                        </div>

                        <div className={`d-flex alef ${customerFormErrors.approvingCondition ? 'checkbox_error_frame' : ''}`}>
                            <div className="form-check ps-0 align-items-center d-flex relative">
                                <div id="approvingCondition_scroll" className="scroll_div"></div>
                                <input className={`pointer form-check-input fa ${customerFormErrors.approvingCondition ? 'error' : ''}`} checked={Boolean(store.customerDetails.approvingCondition)} type="checkbox" id="approvingCondition" onChange={(e) => setCustomerState(e, 'approvingCondition')}/>
                                <label className="form-check-label ps-2 form-text mt-0" htmlFor="approvingCondition">
                                    <span>קראתי ואני מסכים </span>
                                    <Link className="btn-link" to="https://www.mahuti.co.il/terms/">לתנאי השימוש</Link>
                                </label>
                            </div>
                        </div>
                        {customerFormErrors.approvingCondition && <div className="input_alert">{customerFormErrors.approvingCondition}</div>}

                        <div className="pb-4 pt-2">
                            <span className="form-group alef">
                                <small className="d-flex form-text">-התשלום באמצעות כרטיס אשראי </small>
                                <small className={`form-text ${isMobile ? 'd-block text-start' : 'd-flex'}`}>-הפרטים שלך ישמשו רק עבור רישום ותמיכה באתר בהתאם <Link className="btn-link ps-1" to="https://www.mahuti.co.il/privacy/"> למדיניות פרטיות שלנו</Link></small>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
}


export default CustomerDetails;